import { getDataMapper, mapField } from "@/shared";

export const mapRepairAdditionalServiceToServer = getDataMapper(
    {
        additional_service_id: mapField("additionalService", (a) => a.id),
        count: mapField("count", Number),
    },
    { shouldAvoidUndefined: true }
);
